import api from './api'

const eventService = {
  // User-facing
  getMyEvents: (startDate, endDate) =>
    api.get('/events', {
      params: { startDate: startDate.toISOString(), endDate: endDate.toISOString() }
    }),
  getEventSeries: (seriesId) => api.get(`/events/series/${seriesId}`),
  getOccurrence: (occurrenceId) => api.get(`/events/occurrences/${occurrenceId}`),
  registerForOccurrence: (occurrenceId) => api.post(`/events/occurrences/${occurrenceId}/register`),
  cancelRegistration: (occurrenceId) => api.delete(`/events/occurrences/${occurrenceId}/register`),
  getMyRegistrations: () => api.get('/events/my-registrations'),
  downloadOccurrenceICS: (occurrenceId) => `/api/events/occurrences/${occurrenceId}/calendar`,
  downloadSeriesICS: (seriesId) => `/api/events/series/${seriesId}/calendar`,

  // Personal events
  createPersonalEvent: (data) => api.post('/events/personal', data),
  updatePersonalEvent: (seriesId, data) => api.put(`/events/personal/${seriesId}`, data),
  deletePersonalEvent: (seriesId) => api.delete(`/events/personal/${seriesId}`),

  // Admin
  getAdminEvents: (params) => api.get('/admin/events', { params }),
  createPlatformEvent: (data) => api.post('/admin/events', data),
  updatePlatformEvent: (seriesId, data) => api.put(`/admin/events/${seriesId}`, data),
  deletePlatformEvent: (seriesId) => api.delete(`/admin/events/${seriesId}`),
  permanentDeletePlatformEvent: (seriesId) =>
    api.delete(`/admin/events/${seriesId}`, { params: { permanent: 'true' } }),
  adminUpdateOccurrence: (occurrenceId, data) =>
    api.put(`/admin/events/occurrences/${occurrenceId}`, data),
  adminCancelOccurrence: (occurrenceId, data) =>
    api.post(`/admin/events/occurrences/${occurrenceId}/cancel`, data),
  getOccurrenceRegistrations: (occurrenceId) =>
    api.get(`/admin/events/occurrences/${occurrenceId}/registrations`),
  getEventStats: () => api.get('/admin/events/stats'),
  searchUsersForHost: (q) => api.get('/admin/events/search-users', { params: { q } }),

  // Coach
  getCoachEvents: (params) => api.get('/coach/events', { params }),
  createCoachEvent: (data) => api.post('/coach/events', data),
  updateCoachEvent: (seriesId, data) => api.put(`/coach/events/${seriesId}`, data),
  deleteCoachEvent: (seriesId) => api.delete(`/coach/events/${seriesId}`),
  permanentDeleteCoachEvent: (seriesId) =>
    api.delete(`/coach/events/${seriesId}`, { params: { permanent: 'true' } }),
  coachUpdateOccurrence: (occurrenceId, data) =>
    api.put(`/coach/events/occurrences/${occurrenceId}`, data),
  coachCancelOccurrence: (occurrenceId, data) =>
    api.post(`/coach/events/occurrences/${occurrenceId}/cancel`, data),
  coachGetRegistrations: (occurrenceId) =>
    api.get(`/coach/events/occurrences/${occurrenceId}/registrations`),

  // Calendar subscription
  getSubscription: () => api.get('/calendar/subscription'),
  createSubscription: () => api.post('/calendar/subscription'),
  revokeSubscription: () => api.delete('/calendar/subscription')
}

export default eventService
